import { useEffect, useState } from "react";
import useNotification from "../../../hooks/useNotification";
import DashboardServices from "../../../services/DashboardServices";
import { ChoroplethMap } from '@ant-design/maps';
import CandidateGraph from "../CandidateGraph";
import styles from './Candidate.module.css'
import CandidateDataTable from "../CandidateList/CandidateDataTable";

const CandidateHome = () => {
    const { showNotification } = useNotification();
    const [loading, setLoading] = useState(false);
    const [jobsData, setJobsData] = useState({});

    useEffect(() => {
        const fetchUserOverviewData = async () => {
            const res = await DashboardServices.getCandidatesOverview();

            if (res) {
                if (res.statusCode === 1) {
                    setJobsData(res.data);
                } else {
                    handleError(`${res.statusDesc}`);
                }
            } else {
                handleError(`Error: ${res.statusDesc}`);
            }
        };
        fetchUserOverviewData();
    }, []);

    const handleError = (error) => {
        setLoading(false);
        showNotification(error, "error");
    };

    const countryData = [
        { _id: 'United States', count: 6 },
        { _id: 'India', count: 2 },
        { _id: 'United Kingdom', count: 2 },
        { _id: 'Canada', count: 1 },
        { _id: 'Australia', count: 1 }
    ];
    const mapData = countryData.map(country => ({
        country: country._id,
        value: country.count
    }));

    const config = {
        data: mapData, // Provide the country count data
        colorField: 'value', // Field to determine the color intensity
        color: ['#e0f3f8', '#2a7bb6'], // Color range for choropleth
        tooltip: {
            formatter: (datum) => {
                return { name: datum.country, value: datum.value };
            },
        },
        // Optional: configure other map options
        map: 'world', // Use the world map
    };
    return (
        <div className={styles.page_wrap}>
            <div className={styles.title}>Candidates</div>
            <div>
                {/* <ChoroplethMap {...config} /> */}
                <CandidateGraph data={jobsData} />
                <CandidateDataTable />
            </div>
        </div>
    );
};

export default CandidateHome;
